<mat-card appearance="raised" *ngIf="(supportedGroups | includes: 'merchants') && supportedGroups.length === 1">
  <mat-card-title>Page Does Not Support {{entityGroupName$ | async | accountType | titleCase}}s</mat-card-title>
  <mat-divider></mat-divider>
  <br>
  <mat-card-subtitle>Select a merchant account via the account switcher to view this page.</mat-card-subtitle>
</mat-card>

<mat-card appearance="raised" *ngIf="(supportedGroups | includes: 'affiliates') && supportedGroups.length === 1">
  <mat-card-title>Page Does Not Support {{entityGroupName$ | async | accountType | titleCase}}s</mat-card-title>
  <mat-divider></mat-divider>
  <br>
  <mat-card-subtitle>Select an affiliate account via the account switcher to view this page.</mat-card-subtitle>
</mat-card>

<mat-card appearance="raised" *ngIf="(supportedGroups | includes:'merchants') && (supportedGroups | includes: 'affiliates')
  && supportedGroups.length === 2 && this.dashboardApiService.isRootUser$ | async">
  <mat-card-title>Page Does Not Support {{entityGroupName$ | async | accountType | titleCase}}s</mat-card-title>
  <mat-divider></mat-divider>
  <br>
  <mat-card-subtitle>Select a merchant or affiliate account via the account switcher to view this page.</mat-card-subtitle>
</mat-card>

<mat-card appearance="raised" *ngIf="(supportedGroups | includes:'merchants') && (supportedGroups | includes:'affiliates')
  && supportedGroups.length === 2 && (this.dashboardApiService.isRootUser$ | async) === false">
  <mat-card-title>Page Does Not Support {{entityGroupName$ | async | accountType | titleCase}}s</mat-card-title>
  <mat-divider></mat-divider>
  <br>
  <mat-card-subtitle>Select a merchant account via the account switcher to view this page.</mat-card-subtitle>
</mat-card>

<mat-card appearance="raised" *ngIf="(supportedGroups | includes:'root') && supportedGroups.length === 1">
  <mat-card-title>Page Only Supports Admins</mat-card-title>
  <mat-divider></mat-divider>
  <br>
  <mat-card-subtitle>Select an admin account via the account switcher to view this page.</mat-card-subtitle>
</mat-card>

<mat-card appearance="raised" *ngIf="(supportedGroups | includes:'merchant_groups') && (supportedGroups | includes:'merchants')
  && (supportedGroups | includes:'affiliates') && supportedGroups.length === 3">
  <mat-card-title>Page Does Not Support Admins</mat-card-title>
  <mat-divider></mat-divider>
  <br>
  <mat-card-subtitle>Select another account via the account switcher to view this page.</mat-card-subtitle>
</mat-card>

<mat-card appearance="raised" *ngIf="(supportedGroups | includes:'non-root-users')">
  <mat-card-title>Page Does Not Support Root Users</mat-card-title>
  <mat-divider></mat-divider>
  <br>
  <mat-card-subtitle>Log on as a non-root user to view this page.</mat-card-subtitle>
</mat-card>
